<i
  class="ene-icon multi-row-column"
  [style.color]="$any(columnConfig).color || null"
  [ngClass]="expanded ? $any(columnConfig).expandIcon : $any(columnConfig).collapsedIcon"
  (click)="onClick(!expanded, row)"
></i>
